import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ClientsServiceService } from '../services/clients-service.service';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AlertComponent } from '../../../alert/alert.component';
import { PixModalComponent } from '../../../pix-modal/pix-modal.component';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';
import { ClientPipe } from '../licencas/pipes/client.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { catchError, EMPTY, switchMap, take, tap } from 'rxjs';

@Component({
  selector: 'app-clientes',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    AlertComponent,
    PixModalComponent,
    LoadingModalComponent,
    NgxPaginationModule,
    ClientPipe,
  ],
  providers: [provideNgxMask(), ClientsServiceService, ClientPipe],
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
})
export class ClientesComponent {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;
  @ViewChild(PixModalComponent) pixComponent!: PixModalComponent;

  //Variaveis Usuario e Dispositivo
  public menuUser: string = atob(localStorage.getItem('uL') ?? '');

  //Variaveis de cadastro de CLientes
  public formRegistro: FormGroup;

  public openRegistro: boolean = false;

  //Variaveis de listagem dos clientes
  public clients: any = [];

  public clientsInactive: any = [];

  //public currentClientes: any = [];

  public revendedorList: any = [];

  public filterRevendedor: string = 'default';

  public filterName: string = '';

  public revendedorListRegister: any = [];

  //variavell para trocar a tab
  public isTabActive: boolean = true;

  //Variaveis de Paginacao
  public objectPage: any = {
    currentPage: 1,
    itemsPerPage: 5,
    totalPages: 0,
  };

  //Variaveis de cnpj do formulario
  public maskValue: string = '000.000.000-00'; // Máscara inicial (CPF)
  public valorCentavos: number = 0; // Valor armazenado em centavos
  public formattedValue: string = 'R$0,00'; // Valor formatado para exibição

  //Variaveis para edicao do cadastro do cliente
  public formEditClient: FormGroup;
  public activeModalEdit: boolean = false;

  public clientEditSelected: any;

  //variaveis para edicao das configuracoes do cliente
  public activeModalEditConfig: boolean = false;
  public activeModalEditQuantidadeCanais: boolean = false;
  public clientConfigEditSelected: any;
  public formQuantidadeCanais: FormGroup;
  public isLoadingAdicionar: boolean = false;
  public isLoadingAdicionarCredits: boolean = false;

  //Variavel para o modal de editar o host do cliente
  public formEditClientHost: FormGroup;
  public activeModalEditHost: boolean = false;
  public clientEditHostSelected: any;

  //Variavel para o modal de editar senha do cliente
  public activeModalEditPassword: boolean = false;
  public clientEditPasswordSelected: any;
  public formEditClientPassword: FormGroup;
  public typeInputEditPassword: string = 'password';

  //Variavel para parte de deletar o cliente
  public activeModalDeleteClient: boolean = false;
  public clientDeleteSelected: any;

  //Variavel para reativar o cliente
  public activeModalRenewClient: boolean = false;
  public clienteRenewSelected: any;

  constructor(
    private router: Router,
    private clientService: ClientsServiceService,
    private fb: FormBuilder
  ) {
    this.formRegistro = this.fb.group({
      nome: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      revendedor: ['', Validators.required],
      telefone: ['', [Validators.required, Validators.minLength(11)]],
      cpfcnpj: ['', Validators.required],
      password: ['', [Validators.required]],
      host: ['', Validators.required],
      quantidadecanais: ['', Validators.required],
      quantidadeMensagem: ['', Validators.required],
      quantidadeNutricao: ['', Validators.required],
      valorCanal: [''],
    });

    this.formEditClient = this.fb.group({
      idcliente: ['', [Validators.required]],
      nome: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      host: ['', Validators.required],
      password: ['', [Validators.required]],
      revendedor: ['', Validators.required],
      telefone: ['', [Validators.required, Validators.minLength(11)]],
      cpfcnpj: ['', Validators.required],
    });

    this.formEditClientHost = this.fb.group({
      idcliente: ['', [Validators.required]],
      host: ['', Validators.required],
    });

    this.formEditClientPassword = this.fb.group({
      idcliente: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    this.formQuantidadeCanais = this.fb.group({
      idcliente: ['', [Validators.required]],
      quantidadecanais: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    await this.listClients();
    if (this.returnLevel() === 3) {
      await this.listRevendedorRegister();
    }
  }

  public listClients() {
    this.clientService.getClients().subscribe((response: any) => {
      this.clients = response.retorno;
      if (this.isTabActive) {
        this.objectPage.totalPages = Math.ceil(
          this.clients.length / this.objectPage.itemsPerPage
        );
      }
    });

    this.clientService.getClientsInactive().subscribe((response: any) => {
      this.clientsInactive = response;
      if (!this.isTabActive) {
        this.objectPage.totalPages = Math.ceil(
          this.clientsInactive.length / this.objectPage.itemsPerPage
        );
      }
    });
  }

  public async listRevendedor(arrList: any) {
    this.revendedorList = [
      ...new Set(arrList.map((element: any) => element.revendedor)),
    ];
  }

  public async listRevendedorRegister() {
    this.clientService.getRevendedores().subscribe(
      async (response: any) => {
        this.revendedorListRegister = [
          ...new Map(
            response.map((element: any) => [element.revendedor, element])
          ).values(),
        ];
      },
      (error: any) => {
        // if (error.status === 401) {
        //   this.router.navigate(['adm'])
        // } else {
        console.log('Error: ' + error.response);
        // }
      }
    );
  }

  public alterTab(status: boolean) {
    this.isTabActive = status;
    if (this.isTabActive) {
      this.filterRevendedor = 'default';
      this.objectPage.currentPage = 1;
      this.objectPage.totalPages = Math.ceil(
        this.clients.length / this.objectPage.itemsPerPage
      );
      this.listClients();
    } else {
      this.filterRevendedor = 'default';
      this.objectPage.currentPage = 1;
      this.objectPage.totalPages = Math.ceil(
        this.clientsInactive.length / this.objectPage.itemsPerPage
      );
      this.listClients();
    }
  }

  public alterItemPerPage(quantity: Event) {
    const target = quantity.target as HTMLSelectElement;
    this.objectPage.itemsPerPage = Number(target.value);
    this.listClients();
  }

  public alterRevendedor(filter: Event) {
    const filtro = filter.target as HTMLSelectElement;

    this.filterRevendedor = filtro.value;
    this.objectPage.currentPage = 1;
    this.listClients();
  }

  public previousPage() {
    if (this.objectPage.currentPage > 1) {
      this.objectPage.currentPage = this.objectPage.currentPage - 1;
    }
    this.listClients();
  }

  public isFirstPage() {
    if (this.objectPage.currentPage <= 1) return true;

    return false;
  }

  public isLastPage() {
    if (this.objectPage.currentPage >= this.objectPage.totalPages) return true;

    return false;
  }

  public nextPage() {
    this.objectPage.currentPage += 1;

    let offset =
      (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

    this.listClients();
  }

  public async sliceClients(dataClients: any) {
    //Criar o offset =  paginal atual -1 multiplicado pelo total de itens por pagina

    if (this.objectPage.currentPage === 1) {
      let offset =
        (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

      return dataClients.slice(0, this.objectPage.itemsPerPage);
    } else {
      let offset =
        (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

      return dataClients.slice(offset, offset + this.objectPage.itemsPerPage);
    }
  }

  public openModalRegistro() {
    this.openRegistro = true;
  }

  public closeModalRegistro() {
    this.openRegistro = false;
  }

  public returnLevel(): number {
    return Number(atob(localStorage.getItem('uL') ?? ''));
  }

  public onSubmitRegistro() {
    console.log(this.formRegistro.value);
    this.loadingComponent.activeLoading();
    this.clientService.createClient(this.formRegistro.value).subscribe(
      (response: any) => {
        this.formRegistro.reset();
        this.closeModalRegistro();
        this.listClients();
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert('Cliente criado com sucesso!', 'success');
      },
      (error: any) => {
        console.log('Error: ', error.error);
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert(
          `${error.error.status
            .charAt(0)
            .toUpperCase()}+${error.error.status.slice(1)}`,
          'error'
        );
      }
    );
  }

  public alterDocument(event: Event) {
    const value = event.target as HTMLSelectElement;

    if (value.value === 'CPF') {
      this.maskValue = '000.000.000-00';
    }

    if (value.value === 'CNPJ') {
      this.maskValue = '00.000.000/0000-00';
    }
  }

  //Funcoes para editar cadastro do cliente

  public openModalEditClient(client: any) {
    this.activeModalEdit = true;
    this.clientEditSelected = client;
    this.clientEditSelected.cpfcnpj = this.formatarCPFouCNPJ(
      this.clientEditSelected.cpfcnpj
    );
    this.clientEditSelected.telefone = this.formatarCelular(
      this.clientEditSelected.telefone
    );
    this.formEditClient.patchValue({
      idcliente: this.clientEditSelected.idcliente,
      nome: this.clientEditSelected.nome,
      cpfcnpj: this.clientEditSelected.cpfcnpj,
      email: this.clientEditSelected.email,
      telefone: this.clientEditSelected.telefone,
      endereco: this.clientEditSelected.endereco,
      revendedor: this.clientEditSelected.revendedor,
      host: this.clientEditSelected.host,
      password: this.clientEditSelected.password,
    });
  }

  public closeModalEditClient() {
    this.activeModalEdit = false;
  }

  public async sendUpdateClient() {
    //Formatar CPF ou CNPJ antes de enviar
    this.formEditClient.patchValue({
      cpfcnpj: this.formatarCPFouCNPJ(this.formEditClient.value.cpfcnpj),
      telefone: this.formatarCelular(this.formEditClient.value.telefone),
    });

    //Enviando formulario para atualizacoes
    this.clientService.updateClient(this.formEditClient.value).subscribe(
      (response: any) => {
        this.alertComponent.showAlert(
          'Cliente alterado com sucesso!',
          'success'
        );
        this.closeModalEditClient();
        setTimeout(() => {
          this.listClients();
        }, 150);
      },
      (error: any) => {
        this.alertComponent.showAlert(
          'Erro ao tentar atualizar o cliente!',
          'error'
        );
      }
    );
  }

  //Funcoes de formatacao de dados
  public formatarCPFouCNPJ(valor: string): string {
    // Remove qualquer caractere não numérico
    let documentoNumerico = valor.replace(/\D/g, '');

    // Aplica máscara para CPF (11 dígitos)
    if (documentoNumerico.length <= 11) {
      documentoNumerico = documentoNumerico.replace(/(\d{3})(\d)/, '$1.$2');
      documentoNumerico = documentoNumerico.replace(/(\d{3})(\d)/, '$1.$2');
      documentoNumerico = documentoNumerico.replace(
        /(\d{3})(\d{1,2})$/,
        '$1-$2'
      );
    }
    // Aplica máscara para CNPJ (14 dígitos)
    else if (documentoNumerico.length <= 14) {
      documentoNumerico = documentoNumerico.replace(/(\d{2})(\d)/, '$1.$2');
      documentoNumerico = documentoNumerico.replace(/(\d{3})(\d)/, '$1.$2');
      documentoNumerico = documentoNumerico.replace(/(\d{3})(\d)/, '$1/$2');
      documentoNumerico = documentoNumerico.replace(
        /(\d{4})(\d{1,2})$/,
        '$1-$2'
      );
    }

    return documentoNumerico;
  }

  public onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Remove caracteres que não são números
    const rawValue = input.value.replace(/[^\d]/g, '');

    // Converte para centavos
    this.valorCentavos = parseInt(rawValue || '0', 10);
    this.formRegistro.patchValue({
      valorCanal: this.valorCentavos,
    });

    // Divide por 100 para calcular o valor em reais
    const numericValue = this.valorCentavos / 100;

    // Aplica o regex para formatar o valor como moeda
    this.formattedValue = numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    // Atualiza o valor do input
    input.value = this.formattedValue;
  }

  public formatarCelular(valor: string): string {
    // Remove qualquer caractere que não seja numérico
    let celularNumerico = valor.replace(/\D/g, '');

    // Verifica se tem o código do país (por exemplo, +55) e remove
    if (celularNumerico.length > 11 && celularNumerico.startsWith('55')) {
      celularNumerico = celularNumerico.substring(2);
    }

    // Aplica máscara (00) 00000-0000
    if (celularNumerico.length <= 11) {
      celularNumerico = celularNumerico.replace(/(\d{2})(\d)/, '($1) $2'); // DDD
      celularNumerico = celularNumerico.replace(/(\d{5})(\d{1,4})$/, '$1-$2'); // Número
    }

    return celularNumerico;
  }

  public handleSubmitRegisterClient() {
    console.log(this.formRegistro.value);
  }

  //funcoes para editar as configurações do cliente
  public openModalEditConfigClient(client: any) {
    this.clientConfigEditSelected = { ...client };

    console.log("Cliente selecionado: ",this.clientConfigEditSelected);
    this.activeModalEditConfig = true;
  }

  public closeModalEditConfigClient() {
    this.activeModalEditConfig = false;
  }

  public openModalQntChannel() {
    this.activeModalEditQuantidadeCanais = true;
    this.formQuantidadeCanais.patchValue({
      idcliente: this.clientConfigEditSelected.idcliente,
    });

    console.log('Manp de canais: ', this.formQuantidadeCanais.value);
  }

  public closeModalQntChannel() {
    this.activeModalEditQuantidadeCanais = false;
    this.formQuantidadeCanais.reset();
  }

  // public async addChannelClient(idClient: any) {
  //   this.clientService.addOneChannel(idClient, this.menuUser).subscribe(async (response: any) => {
  //     // await this.listClients().then(async () => {
  //     //   setTimeout(async () => {
  //     //     this.reloadingClientConfigSelected(idClient.idcliente);
  //     //   }, 150);
  //     // })
  //     this.listClients();
  //     this.clientConfigEditSelected = {...idClient};
  //   }, (error: any) => {
  //     console.log("Error: ", error.error);
  //   })
  // }

  public addChannelClient(client: any) {
    this.clientService
      .addOneChannel(client, this.menuUser)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  public submitAddQntCanais() {
    console.log(this.formQuantidadeCanais.value);
    this.isLoadingAdicionar = true;
    this.clientService
      .addOneChannel(this.formQuantidadeCanais.value, this.menuUser)
      .subscribe(
        (response: any) => {
          this.pixComponent.showModal(response.qrcode, response.codepix);
          this.isLoadingAdicionar = false;
          this.activeModalEditQuantidadeCanais = false;
          this.formQuantidadeCanais.reset();
        },
        (error: any) => {
          this.isLoadingAdicionar = false;
          this.alertComponent.showAlert('Erro ao gerar codigo pix', 'error');
        }
      );
  }

  public submitAddQntCanaisCredits() {
    if (this.formQuantidadeCanais.invalid) {
      this.alertComponent.showAlert('Informe a quantidade de canais.', 'error');
      return;
    }

    const payload = {
      idClient: this.formQuantidadeCanais.value.idcliente,
      quantidadeCanais: this.formQuantidadeCanais.value.quantidadecanais,
    };

    this.isLoadingAdicionarCredits = true;
    this.clientService
      .addChannelsWithCredits(payload)
      .pipe(
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {
          this.clients = clients.retorno;
          const updated = this.clients.find(
            (c: any) => c.idcliente === payload.idClient
          );
          if (updated) {
            this.clientConfigEditSelected = { ...updated };
          }
        }),
        take(1),
        catchError((error: any) => {
          this.isLoadingAdicionarCredits = false;
          console.error(error);
          const statusMessage = error?.error?.status;
          const message = statusMessage
            ? `Erro: ${statusMessage}`
            : 'Erro ao adicionar canais com creditos.';
          this.alertComponent.showAlert(message, 'error');
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.isLoadingAdicionarCredits = false;
        this.alertComponent.showAlert('Canais adicionados com sucesso!', 'success');
        this.activeModalEditQuantidadeCanais = false;
        this.formQuantidadeCanais.reset();
      });
  }

  // public async removeChannelClient(idClient: number) {
  //   this.clientService.removeOneChannel(idClient, this.menuUser).subscribe(
  //     async (response: any) => {
  //       this.listClients();
  //     },
  //     (error: any) => {
  //       this.alertComponent.showAlert(
  //         'Erro ao tentar adicionar canal!',
  //         'error'
  //       );
  //     }
  //   );
  // }
  public removeChannelClient(client: any) {
    this.clientService
      .removeOneChannel(client, this.menuUser)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  public addMessagePredefined(client: any) {
    this.clientService
      .addMessagePredefined(client)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  public removeMessagePredefined(client: any) {
    this.clientService
      .removeMessagePredefined(client)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  public addNutritionClient(client: any) {
    this.clientService
      .addNutrition(client)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  public removeNutritionClient(client: any) {
    this.clientService
      .removeNutrition(client)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  //Funcoes para o modal de editar host do cliente
  public openModalEditHostClient(client: any) {
    this.activeModalEditHost = true;
    this.clientEditHostSelected = client;
    this.formEditClientHost.patchValue({
      idcliente: this.clientEditHostSelected.idcliente,
      host: this.clientEditHostSelected.host,
    });
  }

  public closeModalEditHostClient() {
    this.activeModalEditHost = false;
  }

  public submitUpdateHostClient() {
    this.clientService
      .updateOnlyHostClient(this.formEditClientHost.value)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Host do cliente alterado com sucesso!',
            'success'
          );
          this.closeModalEditHostClient();
          setTimeout(() => {
            this.listClients();
          }, 150);
        },
        (error: any) => {
          this.alertComponent.showAlert(
            'Erro ao tentar atualizar o host do cliente!',
            'error'
          );
        }
      );
  }

  //Funcoes para o modal de editar senha do cliente
  public openModalEditPasswordClient(client: any) {
    this.activeModalEditPassword = true;
    this.clientEditPasswordSelected = client;
  }

  public closeModalEditPasswordClient() {
    this.activeModalEditPassword = false;
  }

  public toggleVisibility() {
    if (this.typeInputEditPassword === 'password') {
      this.typeInputEditPassword = 'text';
    } else {
      this.typeInputEditPassword = 'password';
    }
  }

  public submitUpdatePasswordClient() {
    //console.log(this.formEditClientPassword)
    this.formEditClientPassword.patchValue({
      idcliente: this.clientEditPasswordSelected.idcliente,
      //senha: this.formEditClientPassword.value.senha
    });
    this.clientService
      .updateOnlyPasswordClient(this.formEditClientPassword.value)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Senha atualizada com sucesso',
            'success'
          );
          this.closeModalEditPasswordClient();
          this.formEditClientPassword.reset();
          this.listClients();
        },
        (error: any) => {
          console.log(error);
          this.alertComponent.showAlert(
            'Erro ao tentar atualizar a senha do cliente!',
            'error'
          );
        }
      );
  }

  //Funcoes para deletar cliente

  public openModalDeleteClient(client: any) {
    this.activeModalDeleteClient = true;
    this.clientDeleteSelected = client;

    console.log('Cliente para deletar: ', this.clientDeleteSelected);
  }

  public closeModalDeleteClient() {
    this.activeModalDeleteClient = false;
    this.clientDeleteSelected = null;
  }

  public submitDeleteClient() {
    console.log('Deletando cliente: ', this.clientDeleteSelected);
    this.clientService
      .deleteClient(this.clientDeleteSelected.idcliente)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Cliente inativado com sucesso!',
            'success'
          );
          this.closeModalDeleteClient();
          setTimeout(() => {
            this.listClients();
          }, 150);
        },
        (error: any) => {
          this.alertComponent.showAlert(
            'Erro ao tentar inativar o cliente!',
            'error'
          );
        }
      );
  }

  //Funcoes para reativar Cliente
  public openModalRenewClient(client: any) {
    this.activeModalRenewClient = true;
    this.clienteRenewSelected = client;
  }

  public closeModalRenewClient() {
    this.activeModalRenewClient = false;
    this.clienteRenewSelected = null;
  }

  public submitRenewClient() {
    console.log('Cliente para ser reativado: ', this.clienteRenewSelected);
    this.clientService
      .renewClient(this.clienteRenewSelected.idcliente)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Cliente reativado com sucesso!',
            'success'
          );
          this.closeModalRenewClient();
          setTimeout(() => {
            this.listClients();
          }, 150);
        },
        (error: any) => {
          this.alertComponent.showAlert(
            'Erro ao tentar reativar cliente!',
            'error'
          );
          this.closeModalRenewClient();
          setTimeout(() => {
            this.listClients();
          }, 150);
        }
      );
  }


  //Funcoes de manipulacao de menu Agenda
  handleToggleAgendaMenu(client: any){
    try {
        this.clientService
      .handleAgendaMenu(client)
      .pipe(
        // após adicionar o canal, recarrega a lista
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {

          this.clients = clients.retorno; // atualiza a lista do componente
          // encontra o cliente atualizado
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          if (updated) {
            // seta o selecionado com os dados frescos da API
            this.clientConfigEditSelected = { ...updated };
          } else {
            // fallback: caso não encontre (ex.: cliente removido)
            this.clientConfigEditSelected = null;
          }
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();    
    } catch (error: any) {
      this.alertComponent.showAlert("", "error");
    }
  }

  handleToggleClinicorpMenu(client: any){
    try {
      this.clientService
      .handleClinicorpMenu(client)
      .pipe(
        switchMap(() => this.clientService.getClients()),
        tap((clients) => {
          this.clients = clients.retorno;
          const updated = this.clients.find(
            (c: any) => c.idcliente === client.idcliente
          );
          this.clientConfigEditSelected = updated ? { ...updated } : null;
        }),
        take(1),
        catchError((err) => {
          console.error('Error: ', err?.error || err);
          return EMPTY;
        })
      )
      .subscribe();
    } catch (error: any) {
      this.alertComponent.showAlert("", "error");
    }
  }
}
